const actions = {
  GET_DIGITAL_CARDS_BEGIN: 'GET_DIGITAL_CARDS_BEGIN',
  GET_DIGITAL_CARDS: 'GET_DIGITAL_CARDS',
  GET_DIGITAL_CARDS_ERR: 'GET_DIGITAL_CARDS_ERR',
  GENERATE_DIGITAL_CARD_BEGIN: 'GENERATE_DIGITAL_CARD_BEGIN',
  GENERATE_DIGITAL_CARD: 'GENERATE_DIGITAL_CARD',
  GENERATE_DIGITAL_CARD_ERR: 'GENERATE_DIGITAL_CARD_ERR',

  getDigitalCards: data => {
    return {
      type: actions.GET_DIGITAL_CARDS,
      data,
    };
  },

  getDigitalCardsBegin: () => {
    return {
      type: actions.GET_DIGITAL_CARDS_BEGIN,
    };
  },

  getDigitalCardsError: err => {
    return {
      type: actions.GET_DIGITAL_CARDS_ERR,
      err,
    };
  },

  generateDigitalCard: data => {
    return {
      type: actions.GENERATE_DIGITAL_CARD,
      data,
    };
  },

  generateDigitalCardBegin: () => {
    return {
      type: actions.GENERATE_DIGITAL_CARD_BEGIN,
    };
  },

  generateDigitalCardError: err => {
    return {
      type: actions.GENERATE_DIGITAL_CARD_ERR,
      err,
    };
  },
};

export default actions;
